const data = [
    { id: 0, name: "Pendente" },
    { id: 1, name: "Aprovado" },
    { id: 2, name: "Rejeitado" },
    // AJ pediu complemento: o credor/procurador regulariza o mesmo pedido.
    { id: 3, name: "Regularização solicitada" },
  ];
  
  export default [...data];
  